import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import './Dimenssions.css';
import axiosInstance from '../../../Config/axiosInstance';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Alert, Snackbar } from '@mui/material';

const AddDimenssions = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        dimenssions: "",
    });

    //state uri pentru validare si notificari
    const [dimensionError, setDimensionError] = useState("");
    const [isSubmiting, setIsSubmitting] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "error"
    })

    //functie pentru verificarea existentei dimensiunii
    const checkDimensionExists = async (dimenssion) => {
        if (!dimenssion.trim()) {
            return false;
        }

        try {
            const response = await axiosInstance.get("/dimensions/check-name/", {
            params: { dimenssions: dimenssion.trim() }
            });
            return response.data.exists;
        } catch (error) {
            console.error("Error checking dimension: ", error);
            return false;
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        //reseteaza eroarea cand utilizatorul modifica campul
        if(dimensionError) {
            setDimensionError("");
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({...snackbar, open: false});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        //prevenire submit multiplu
        if(isSubmiting) return;
        setIsSubmitting(true);

        try {
            const dimensionExists = await checkDimensionExists(formData.dimenssions);
            if(dimensionExists) {
                setDimensionError("This dimension already exists in the system!");
                setSnackbar({
                    open: true,
                    message: "The dimension already exists. Please enter a unique dimension!",
                    severity: "error"
                });
                setIsSubmitting(false);
                return;
            }

            //daca dimensiunea nu exista, nu trimitem datele
            const dimenssionResponse = await axiosInstance.post("/dimensions/", formData);
            console.log("Created successfully: ", dimenssionResponse.data);

            //afisam un mesaj de succes
            setSnackbar({
                open: true,
                message: "The dimension was created succesfully!",
                severity: "success"
            })

            //navigam inapoi dupa un scurt delay
            setTimeout(() => {
                navigate(-1);
            }, 1500);
        } catch (error) {
            console.error("Error creating dimenssions", error.response?.data || error.message);

            //verificam daca eroarea vine de la backend 
            if(error.response?.status === 400) {
                const errorMessage = error.response?.data.dimension || 
                                    error.response?.data?.message || 
                                    "";

                if(errorMessage.includes("already exists") || 
                    errorMessage.includes("duplicate") || 
                    error.response?.data?.dimenssions?.includes("already exists")) {
                        setDimensionError("This dimension already exists in the system!");
                        setSnackbar({
                            open: true,
                            message: "The dimension already exists. Please enter a unique dimension!",
                            severity: "error"
                        });
                    } else {
                        setSnackbar({
                            open: true, 
                            message: "An error occurred while saving the dimension.",
                            severity: "error"
                        });
                    }
            } else {
                setSnackbar({
                    open: true, 
                    message: "An error occurred while saving the dimension.",
                    severity: "error"
                });
            }
            setIsSubmitting(false);
        }
    };

    return (
        <>
        <div className='dimenssions-page'>
        <div className='add-dimenssions-container'>
            <div className='dimenssions-header'>
                <ArrowBackIcon className="back-arrow" onClick={() => navigate(-1)} />
                <h2 className="add-materials-title">Create Dimension</h2>
            </div>
        </div>

        <hr className="title-separator" />
        <div className='add-dimenssions-container'>            
            <form onSubmit={handleSubmit} className='add-dimenssions-form' >
                <div className='form-group'>
                    <label htmlFor='dimenssions' className='label'>
                        Dimension<span className='required-star'>*</span>
                    </label>
                    <input 
                        id="dimenssions"
                        type="text"
                        name="dimenssions"
                        value={formData.dimenssions}
                        onChange={handleChange}
                        className='input'
                        required
                    /> 
                    {dimensionError && (
                        <div className='erorr-message' style={{color: '#d32f2f', fontSize: '0.875rem'}}>
                            {dimensionError}
                        </div>
                    )}
                </div>

                <button 
                    type="submit" 
                    className='button-save'
                    disabled={isSubmiting}
                >
                    {isSubmiting ? "Saving..." : "Save"}
                </button>
            </form>
        </div>
        </div>

        {/* snackbar pentru notificari */}
        <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            <Alert
                onClose={handleCloseSnackbar}
                severity={snackbar.severity}
                sx={{width: '100%'}}
            >
                {snackbar.message}
            </Alert>
        </Snackbar>
        </>
    );
};

export default AddDimenssions;